import { render, staticRenderFns } from "./excel.vue?vue&type=template&id=2b8ac44c&scoped=true&"
import script from "./excel.vue?vue&type=script&lang=js&"
export * from "./excel.vue?vue&type=script&lang=js&"
import style0 from "./excel.vue?vue&type=style&index=0&id=2b8ac44c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8ac44c",
  null
  
)

export default component.exports